import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import UpdownArrow from '../../assets/images/updown-arrow.png'

import DataTable from "../../components/Datatable/DataTable";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../components/Input/StringInput/StringInput";
import Button from "../../components/Button/Button";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import { numFormat } from "../../hoc/Shared/utility";

class DelayBonusListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCard: false,
        };
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber =
            (this.props.totalRecords - rowIndex - ((this.props.activePage - 1) * this.props.limit))
        return <span>{rowNumber}</span>;
    };

    toggleCard = () => {
        this.setState({
            showCard: !this.state.showCard,
        });
    };

    render() {
        const { t } = this.props;
        let permission = this.props.permission ? this.props.permission : [];
        let rsListing = [];
        let stCls = {
            0: "primary",
            1: "success",
            2: "danger",
            3: "secondary",
            4: "danger",
        };

        const columns = [
            { text: t('transaction.no'), dataField: 'no', formatter: this.noFormatter, headerStyle: { width: '60px', textAlign: 'center' } },
            { text: t('transaction.order-id'), dataField: 'order_id', sort: true, onSort: this.props.onSort, headerStyle: { width: "115px" } },
            { text: t('transaction.member'), dataField: 'username', sort: true, onSort: this.props.onSort },
            { text: t('delay-bonus.name'), dataField: 'name', sort: true, onSort: this.props.onSort },
            { text: t('transaction.amount'), dataField: 'credit', sort: true, onSort: this.props.onSort, headerStyle: { width: '120px' } },
            { text: t('transaction.status'), dataField: 'status', sort: true, onSort: this.props.onSort, headerStyle: { width: "96px" }, },
            { text: t('member.country'), dataField: 'memberCountry', sort: true, onSort: this.props.onSort, headerStyle: { width: "96px" }, },
            { text: t('transaction.create-date'), dataField: 'create_date', sort: true, onSort: this.props.onSort },
            { text: t('transaction.approval-date'), dataField: 'approve_date', sort: true, onSort: this.props.onSort },
            {
                text: t("transaction.update-by"),
                dataField: "update_by",
                sort: true,
                onSort: this.props.onSort,
            },
            { 
                text: t("global.action"), 
                dataField: "action",
                hidden: permission.includes("delay_bonus_approve") ? false : true, 
            },
        ];

        if (this.props.data) {
            rsListing = this.props.data.map((val, idx) => {
                let stVal = "";
                let orderIdVal = "";
                let userNameVal = "";
                let num_format = numFormat(val.currency);

                stVal = (
                    <span className={`badge-${stCls[val.status]}`}>
                        {t(`transaction.status-desc.${val.status}`)}{" "}
                    </span>
                );

                orderIdVal = permission.includes("delay_bonus_details_access") ? (
                    <b>
                        <a
                            href="/#"
                            onClick={(event) =>
                                this.props.editHandler(event, val.id)
                            }
                        >
                            {val.order_id}
                            <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                        </a>
                    </b>
                ) : (
                    val.order_id
                );

                const status01 = permission.includes("delay_bonus_approve")
                let actionVal = (status01)  ? (
                    val.status === 0 || val.status === 3 ? (
                        <div className="btn-group">
                            {permission.includes("delay_bonus_approve") && (
                                <a
                                    href="/#"
                                    onClick={(event) =>
                                        this.props.delayBonusApproveHandler(
                                            event,
                                            val.id,
                                            val.order_id,
                                        )
                                    }
                                    className="btn btn-md success-btn"
                                    data-toggle="tooltip"
                                    title="approve"
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </a>
                            )}
                        </div>
                    ) : (
                        ""
                    )
                ) : (
                    ""
                );

                let amtVal =
                    (val.promotion_transaction_id > 0)
                        ?
                        <a href="/#" onClick={(event) => this.props.detailsHandler(event, val.promotion_transaction_id)}>
                            <span className={`badge-success`}>{new Intl.NumberFormat("en-US", num_format).format(val.credit)}</span>
                        </a>
                        : new Intl.NumberFormat("en-US", num_format).format(val.credit);
                userNameVal = permission.includes("member_view") ? (
                    <b>
                        <a href="/#" onClick={(event) => this.props.redirectHandler(event, val.member_id, val.username)}>
                            {val.username}
                        </a>
                    </b>
                ) : (
                    val.username
                );
                return {
                    no: idx,
                    order_id: orderIdVal,
                    username: userNameVal,
                    name:
                        (val.name && val.name.length > 15)
                            ? val.name.substring(0, 15) + "..."
                            : val.name,
                    credit: amtVal,
                    status: stVal,
                    memberCountry: t(`global.country_shortcode.${val.memberCountry}`),
                    create_date: val.create_date,
                    approve_date: val.approve_date,
                    update_by: val.update_by,
                    action: actionVal,
                };
            });
        }

        return (
            <Auxiliary>
                <div className="breadcrumb-header justify-content-between">
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">
                                {t("delay-bonus.title")}
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-xl-12">
                        <div className="card card-body">
                            <div className="col mt-auto">
                                {this.props.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                                    <div
                                        className={`form-horizontal filter-function row ${this.state.showCard ? "open" : "close"
                                            } filter-wrapper-1`}
                                    >
                                        <div className="col-md-3 col-6 ">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.create-date")}
                                                </label>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <FontAwesomeIcon
                                                            icon={faCalendarCheck}
                                                        />
                                                    </span>
                                                    <DateTimePicker
                                                        id="transaction_date"
                                                        name="transaction_date"
                                                        className="form-control filter-input"
                                                        range={true}
                                                        timePicker={true}
                                                        value={
                                                            this.props.filter
                                                                .transaction_date
                                                        }
                                                        onChange={
                                                            this.props.onInputChange
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6 ">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.member")}
                                                </label>
                                                <StringInput
                                                    id="username"
                                                    name="username"
                                                    value={this.props.filter.username}
                                                    onChange={this.props.onInputChange}
                                                    className="filter-input"
                                                    onSearchPress={(evt) =>
                                                        evt.key === "Enter" &&
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6 ">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.order-id")}
                                                </label>
                                                <StringInput
                                                    id="order_id"
                                                    name="order_id"
                                                    value={this.props.filter.order_id}
                                                    onChange={this.props.onInputChange}
                                                    className="filter-input"
                                                    onSearchPress={(evt) =>
                                                        evt.key === "Enter" &&
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6 ">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.status")}
                                                </label>
                                                <div className="select-input">
                                                    <select
                                                        className="form-control filter-input"
                                                        id="status"
                                                        name="status"
                                                        onChange={this.props.onInputChange}
                                                        value={this.props.filter.status}
                                                    >
                                                        <option value=""></option>
                                                        {this.props.ddStatus &&
                                                            this.props.ddStatus.map(
                                                                (val, idx) => {
                                                                    return (
                                                                        <option
                                                                            key={val.id}
                                                                            value={val.id}
                                                                        >
                                                                            {t(
                                                                                `transaction.${val.desc}`
                                                                            )}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                    </select>
                                                    <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                                                </div>

                                            </div>
                                        </div>     

                                         <div className="col-md-3 col-6 ">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("member.country")}
                                                </label>
                                                <div className="select-input">
                                                    <select
                                                        className="form-control filter-input"
                                                        id="member_country"
                                                        name="member_country"
                                                        onChange={this.props.onInputChange}
                                                        value={this.props.filter.member_country}
                                                    >
                                                        <option value=""></option>
                                                        <option value="all">{t('global.all')}</option>
                                                        {this.props.ddMemberCountry &&
                                                            this.props.ddMemberCountry.map(
                                                                (val, idx) => {
                                                                    return (
                                                                        <option
                                                                            key={val.id}
                                                                            value={val.id}
                                                                        >
                                                                             {t(`global.country_shortcode.${val.shortcode}`)}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                    </select>
                                                    <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                                                </div>

                                            </div>
                                        </div>                     

                                        <div className="col mt-auto d-block">
                                            <div className="d-flex">
                                                <Button
                                                    typeButton="button"
                                                    classValue="btn btn-blue"
                                                    idValue="filter"
                                                    buttonName={t("global.filter")}
                                                    clicked={() =>
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                                &nbsp;
                                                <Button
                                                    typeButton="button"
                                                    classValue="btn btn-secondary"
                                                    idValue="reset"
                                                    buttonName={t("global.reset")}
                                                    clicked={() =>
                                                        this.props.clearHandler()
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </div>
                                )}
                            </div>

                            <div
                                className="show-btn"
                                onClick={() => this.toggleCard()}
                            >
                                {this.state.showCard ? (
                                    <AiFillMinusCircle />
                                ) : (
                                    <AiFillPlusCircle />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header pb-0">
                                <div className="">
                                    <div className="d-flex pb-3">
                                        <h4 className="card-title mg-b-0">
                                            {t("delay-bonus.listing")}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="no"
                                        data={rsListing}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "activePage"
                                            )
                                        }
                                        sizePerPageHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "limit"
                                            )
                                        }
                                        searchChangeHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "searchValue"
                                            )
                                        }
                                        searchValue={this.props.searchValue}
                                        classValue="dataTable table-bordered text-justify text-center deposit__table"
                                        loading={this.props.loading}
                                        hideSearchBar={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(DelayBonusListing);